import CommentsNumberCounter from './CommentsNumberCounter'
import View from '../../View'

export default class CommentsNumberContainer extends View {
    constructor({
        onClick = () => {}
    } = {}) {
        super()

        this.commentsCounter = new CommentsNumberCounter({
            onClick: onClick,
        })

        this.state = {
            commentsNumber: 0,
        }

        this.onStatePropertyChanged('commentsNumber', (number) => {
            this.commentsCounter.setState(this.state)
            this.commentsCounter.toggle(number !== 0)
        })
    }

    afterRender() {
        this.commentsCounter = this.commentsCounter.init(this.$containerEl)

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/components/CommentsNumberContainer.js